import { MinhaEmpresaRepository } from "../repository/minha_empresa_repository";

export class MinhaEmpresaService {
	constructor() {
		this.minhaEmpresaRepository = new MinhaEmpresaRepository();
	}

	async get() {
		return await this.minhaEmpresaRepository.get();
	}

	async update(dados) {
		return await this.minhaEmpresaRepository.update(dados);
	}

	async getLogo() {
		return await this.minhaEmpresaRepository.getLogo();
	}

	async updateLogo(arquivo) {
		return await this.minhaEmpresaRepository.updateLogo(arquivo);
	}

	async deleteLogo() {
		return await this.minhaEmpresaRepository.deleteLogo();
	}
}
